import { useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  height: fit-content;
`;

const TabsContainer = styled.div`
  width: 100%;
  display: flex;
`;

const Tab = styled.button`
  flex: 1;
  padding: 16px;
  font-size: 16px;
  font-weight: ${(props) => (props.isActive ? "450" : "400")};
  color: ${(props) => (props.isActive ? "#000" : "#666")};
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    background-color: #f0f0f0;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: ${(props) => (props.isActive ? "3px" : "0")};
    background-color: #000;
    transition: height 0.2s ease;
  }
`;

const ContentContainer = styled.div`
  padding: 24px;
  /* min-height: 200px; */
  background-color: #fff;
`;

const Content = styled.div`
  display: ${(props) => (props.isActive ? "block" : "none")};
  animation: fadeIn 0.3s ease;
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

function ProductTabbedDescription({ description }) {
  const [activeTab, setActiveTab] = useState(0);

  const tabContent = [
    {
      title: "Description",
      content: description,
    },
    {
      title: "Specifications",
      content: "No Specifications",
    },
    {
      title: "Reviews",
      content: "No Reviews",
    },
  ];

  return (
    <Wrapper>
      <TabsContainer>
        {tabContent.map((tab, index) => (
          <Tab
            key={index}
            isActive={activeTab === index}
            onClick={() => setActiveTab(index)}
          >
            {tab.title}
          </Tab>
        ))}
      </TabsContainer>

      <ContentContainer>
        {tabContent.map((tab, index) => (
          <Content key={index} isActive={activeTab === index}>
            {/* {tab.content.split("\n").map((line, i) => (
              <p key={i} style={{ margin: "8px 0" }}>
                {line}
              </p>
            ))} */}
            {tab.content}
          </Content>
        ))}
      </ContentContainer>
    </Wrapper>
  );
}

export default ProductTabbedDescription;
